import React from "react";
import { ESTADOS, devTxt, hhmm } from "./statusHelper";

const TRACK_HEIGHT = 126;

const chip = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  background: "#fff",
  border: "1px solid #e9ebec",
  borderRadius: "100px",
  padding: "3px 10px",
  fontSize: "11px",
  whiteSpace: "nowrap",
};

const Dot = ({ color }) => (
  <span style={{ width: 7, height: 7, borderRadius: "50%", background: color, display: "inline-block" }} />
);

const RamalRow = ({ row, nextSalida, selectedId, onSelect }) => {
  const { counts } = row;
  const hasSalidas = row.units.length > 0;
  const trackMinWidth = Math.max(900, row.stations.length * 48);

  return (
    <div
      style={{
        padding: "12px 22px 0",
        borderBottom: "1px solid #e9ebec",
        background: counts.que >= 4 ? "#fffafa" : "#fff",
      }}
    >
      <div className="d-flex align-items-center flex-wrap" style={{ gap: "12px", marginBottom: "4px" }}>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: 22,
            height: 22,
            padding: "0 4px",
            borderRadius: 6,
            background: "#272a3a",
            color: "#fff",
            fontSize: "11.5px",
            fontWeight: 600,
          }}
        >
          {row.numero}
        </span>
        <span style={{ fontSize: "13.5px", fontWeight: 600, letterSpacing: "-.01em" }}>{row.nombre}</span>
        <span style={{ fontSize: "11px", color: "#777a89" }}>{row.meta}</span>
        <div style={{ flex: 1 }} />
        <div className="d-flex align-items-center flex-wrap" style={{ gap: "7px" }}>
          <span style={{ ...chip, background: row.scoreEstado.bg, borderColor: row.scoreEstado.bd }}>
            Atraso prom. <b style={{ color: row.scoreEstado.ink, fontSize: "12px" }}>{row.score}′</b>
          </span>
          <span style={{ width: 1, height: 16, background: "#e9ebec" }} />
          <span style={chip}>
            <Dot color={ESTADOS.tie.color} />
            En tiempo <b>{counts.tie + counts.ade}</b>
          </span>
          <span style={chip}>
            <Dot color={ESTADOS.rie.color} />
            En riesgo <b>{counts.rie}</b>
          </span>
          <span
            style={{
              ...chip,
              background: counts.que > 0 ? ESTADOS.que.bg : "#fff",
              borderColor: counts.que > 0 ? ESTADOS.que.bd : "#e9ebec",
            }}
          >
            <Dot color={ESTADOS.que.color} />
            Quemadas <b>{counts.que}</b>
          </span>
        </div>
      </div>

      {hasSalidas ? (
        <div style={{ overflowX: "auto", overflowY: "hidden" }}>
          <div style={{ minWidth: trackMinWidth, padding: "0 36px" }}>
            <div style={{ position: "relative", height: TRACK_HEIGHT + row.offset }}>
              <div style={{ position: "absolute", left: 0, right: 0, top: row.lineTop, height: 0 }}>
                {row.turnLeft != null ? (
                  <>
                    <div style={{ position: "absolute", left: 0, width: `${row.turnLeft}%`, height: 5, borderRadius: 3, background: "#495057" }} />
                    <div style={{ position: "absolute", left: `${row.turnLeft}%`, right: 0, height: 5, borderRadius: 3, background: "#adb5bd" }} />
                  </>
                ) : (
                  <div style={{ position: "absolute", left: 0, right: 0, height: 5, borderRadius: 3, background: "#495057" }} />
                )}
              </div>

              {row.stations.map((s) => (
                <div
                  key={s.key}
                  style={{ position: "absolute", left: `${s.left}%`, top: 0, width: 0 }}
                >
                  <div
                    title={s.isTurn ? `Retorno · ${s.name}` : s.name}
                    style={{
                      position: "absolute",
                      left: 0,
                      top: row.lineTop + 2.5 - (s.size + 4) / 2,
                      width: s.size,
                      height: s.size,
                      borderRadius: s.isTurn ? 2 : "50%",
                      background: s.major ? "#272a3a" : "#8a93a5",
                      border: "2px solid #fff",
                      boxSizing: "content-box",
                      transform: s.isTurn ? "translateX(-50%) rotate(45deg)" : "translateX(-50%)",
                      zIndex: 2,
                    }}
                  />
                  <div
                    title={s.name}
                    style={{
                      position: "absolute",
                      left: 0,
                      transform: "translateX(-50%)",
                      top: s.labelTop + row.offset,
                      fontSize: "9.5px",
                      lineHeight: 1.1,
                      fontWeight: s.major ? 700 : 500,
                      letterSpacing: ".02em",
                      color: s.major ? "#272a3a" : "#6b7280",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {s.name}
                  </div>
                </div>
              ))}

              {row.located.map((u) => {
                const est = ESTADOS[u.estado];
                const selected = u.id === selectedId;
                return (
                  <div
                    key={u.id}
                    style={{
                      position: "absolute",
                      left: `${u.percent}%`,
                      top: row.unitTop(u.lane),
                      width: 0,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      zIndex: selected ? 100 : u.z,
                    }}
                  >
                    <div style={{ marginBottom: 2, fontSize: "9.5px", lineHeight: 1.1, fontWeight: 700, color: est.ink, whiteSpace: "nowrap" }}>
                      {devTxt(u.desv)}
                    </div>
                    <div
                      role="button"
                      tabIndex={0}
                      title={`Unidad ${u.numero} · ${est.label}`}
                      className={"salidas-status-unit" + (selected ? " is-selected" : "")}
                      onClick={() => onSelect(u.id)}
                      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onSelect(u.id)}
                      style={{ background: est.color }}
                    >
                      {u.numero}
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={{ position: "relative", height: 20, margin: "0 0 12px" }}>
              <div style={{ position: "absolute", left: 0, right: 0, top: 8, height: 2, background: "#eff2f7" }} />
              {row.gaps.map((g) => (
                <div
                  key={g.key}
                  title={`${g.min} min entre unidades ${g.entre[0]} y ${g.entre[1]}`}
                  style={{
                    position: "absolute",
                    left: `${g.left}%`,
                    width: `${g.width}%`,
                    top: 0,
                    height: 18,
                    background: g.bg,
                    border: `1px solid ${g.bd}`,
                    borderRadius: 4,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "10px",
                    fontWeight: 700,
                    color: "#272a3a",
                    overflow: "hidden",
                  }}
                >
                  {g.min}′
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center" style={{ height: 54, gap: "12px" }}>
          <div style={{ flex: 1, height: 0, borderTop: "2px dashed #ced4da" }} />
          <span style={{ fontSize: "11px", color: "#777a89", whiteSpace: "nowrap" }}>
            Sin salidas activas
            {nextSalida && (
              <>
                {" "}· próxima salida programada <b>{hhmm(nextSalida)}</b>
              </>
            )}
            {nextSalida === false && " · sin más salidas programadas hoy"}
          </span>
          <div style={{ flex: 1, height: 0, borderTop: "2px dashed #ced4da" }} />
        </div>
      )}
    </div>
  );
};

export default RamalRow;
